import {Amplify} from 'aws-amplify';

import {stage} from '../config/stage';

// get config
import {config} from '../config/amplify';
import {ConsoleLogger} from 'aws-amplify/utils';

Amplify.configure(config);

stage === 'ide'
    ? (ConsoleLogger.LOG_LEVEL = 'DEBUG')
    : (ConsoleLogger.LOG_LEVEL = 'INFO');

// FNP-958: the global is only read for the RUM/analytics handles attached to
// it, so an index signature of `unknown` is enough and keeps the rest of the
// DOM Window typing intact rather than replacing it with `any`.
declare let window: Window & { [key: string]: unknown };

window.LOG_LEVEL = 'DEBUG';
